import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';
import './contact-form.styles.scss';

const ContactForm = () => {
  const form = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const sendEmail = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    // EmailJS configuration - Two ways to configure:
    // Option 1: Use environment variables (recommended) - copy .env.example to .env and update
    // Option 2: Replace the values directly below with your EmailJS credentials
    // const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID || 'YOUR_GMAIL_SERVICE_ID';
    // const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'YOUR_EMAIL_TEMPLATE_ID';
    // const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'YOUR_EMAILJS_PUBLIC_KEY';


    const SERVICE_ID = 'Rmt_Gmail';
    const TEMPLATE_ID = 'template_v517plk';
    const PUBLIC_KEY = 'Za0tEvmCpz3ujfuI4';

    // Check if EmailJS credentials are configured
    if (SERVICE_ID.includes('YOUR_') || TEMPLATE_ID.includes('YOUR_') || PUBLIC_KEY.includes('YOUR_')) {
      console.warn('EmailJS not configured. Please update credentials in contact-form.component.jsx');
      setSubmitStatus('config-error');
      setIsSubmitting(false);
      return;
    }

    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, form.current, PUBLIC_KEY)
      .then((result) => {
        console.log('Email sent successfully to Gmail:', result.text);
        setSubmitStatus('success');
        setIsSubmitting(false);
        form.current.reset();
      }, (error) => {
        console.error('Email send failed:', error.text);
        setSubmitStatus('error');
        setIsSubmitting(false);
      });
  };

  return (
    <div className="contact-form-container">
      <div className="contact-form-wrapper">
        <h2 className="form-title">
          <span className="form-icon">�️</span>
          Request Database Assessment
        </h2>
        <p className="form-subtitle">
          Ready to optimize your database performance? Our expert DBAs will provide a comprehensive 
          assessment and recommendations within 24 hours.
        </p>

        <form ref={form} onSubmit={sendEmail} className="contact-form">
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="user_name">Full Name *</label>
              <input
                type="text"
                id="user_name"
                name="user_name"
                required
                placeholder="Enter your full name"
              />
            </div>
            <div className="form-group">
              <label htmlFor="user_email">Email Address *</label>
              <input
                type="email"
                id="user_email"
                name="user_email"
                required
                placeholder="Enter your email address"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="company_name">Company Name</label>
              <input
                type="text"
                id="company_name"
                name="company_name"
                placeholder="Enter your company name"
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="service_interest">Service Interest</label>
            <select id="service_interest" name="service_interest">
              <option value="">Select a service</option>
              <option value="Database Assessment">Free Database Assessment</option>
              <option value="MySQL Administration">MySQL Administration</option>
              <option value="PostgreSQL Services">PostgreSQL Services</option>
              <option value="SQL Server DBA">SQL Server DBA</option>
              <option value="Oracle Database">Oracle Database</option>
              <option value="MongoDB Administration">MongoDB Administration</option>
              <option value="Database Migration">Database Migration</option>
              <option value="Performance Optimization">Performance Optimization</option>
              <option value="24/7 Monitoring">24/7 Database Monitoring</option>
              <option value="General Consultation">General Database Consultation</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="message">Message *</label>
            <textarea
              id="message"
              name="message"
              required
              placeholder="Tell us about your project requirements, timeline, and how we can help you..."
              rows="5"
            ></textarea>
          </div>

          <button 
            type="submit" 
            className={`submit-btn ${isSubmitting ? 'submitting' : ''}`}
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <span className="loading-spinner"></span>
                Sending Message...
              </>
            ) : (
              <>
                <span className="btn-icon">🚀</span>
                Send Message
              </>
            )}
          </button>

          {submitStatus === 'success' && (
            <div className="status-message success">
              <span className="status-icon">✅</span>
              Message sent successfully! We'll get back to you soon.
            </div>
          )}

          {submitStatus === 'error' && (
            <div className="status-message error">
              <span className="status-icon">❌</span>
              Failed to send message. Please try again or contact us directly.
            </div>
          )}

          {submitStatus === 'config-error' && (
            <div className="status-message error">
              <span className="status-icon">⚙️</span>
              EmailJS not configured yet. Please follow the setup guide in EMAILJS_GMAIL_SETUP.md
            </div>
          )}
        </form>

        <div className="contact-info">
          <div className="contact-item">
            <span className="contact-icon">📧</span>
            <span>info@rmt-dba.com</span>
          </div>
          <div className="contact-item">
            <span className="contact-icon">🌐</span>
            <span>www.rmt-dba.com</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
